import { render, staticRenderFns } from "./AcuteRhinitis.vue?vue&type=template&id=26457412"
import script from "./AcuteRhinitis.vue?vue&type=script&lang=js"
export * from "./AcuteRhinitis.vue?vue&type=script&lang=js"
import style0 from "./AcuteRhinitis.vue?vue&type=style&index=0&id=26457412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports